import React, { createContext, useCallback, useContext, useState } from "react";

const PaywallCtx = createContext({ open: () => {}, close: () => {}, payload: null });

export function PaywallProvider({ children }) {
  const [payload, setPayload] = useState(null);

  const open = useCallback((p) => {
    setPayload(p || { message: "Your access has expired." });
  }, []);
  const close = useCallback(() => setPayload(null), []);

  return (
    <PaywallCtx.Provider value={{ open, close, payload }}>
      {children}
    </PaywallCtx.Provider>
  );
}

export function usePaywall() {
  return useContext(PaywallCtx);
}
